import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import GenericIconProps from 'ui/src/icons/_icon.type';
import useFooterThemes from './themes';

export type SocialMediaItemProps = {
  name: string;
  link: string;
  className?: string;
  Icon: React.ComponentType<GenericIconProps>;
};

export default function SocialMediaItem({ name, link, className = '', Icon }: SocialMediaItemProps) {
  const { footerSocialIconsClasses } = useFooterThemes();

  return (
    <li className={className}>
      <a
        aria-label={name}
        href={link}
        target="_blank"
        rel="noreferrer"
        className={twMerge(footerSocialIconsClasses)}
      >
        <Icon id={`footer-${name.toLowerCase()}-icon`} className="h-4 w-4 lg:h-6 lg:w-6" />
      </a>
    </li>
  );
}
